



























import { Component, Prop, Vue } from "vue-property-decorator";
import { ISegmentTypes } from "@/data/enums/segments";
import { IBulkAction } from "@/models/bulkactions";
import { IBulkActionProvider } from "@/models/providers/bulkAction";

@Component({
  components: {
    "bulk-action-provider": () =>
      import("@/components/app/admin/automation/bulkActionProvider.vue")
  }
})
export default class ClientBulkActionView extends Vue {
  // Props
  @Prop({ default: undefined })
  public bulkActionId!: IBulkAction["id"];

  @Prop({ default: () => () => [] })
  public routes!: () => any[];

  // Data
  public segmentType = ISegmentTypes.CLIENT;

  // Methods
  public onNotFound(vm: IBulkActionProvider & Vue) {
    return vm.$router
      .push({ name: "adminClientBulkActions" })
      .catch(err => err);
  }
}
